import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "../../../../utils/notifications";
import LoaiPhieuThuChiApi from "service/QuanTriHeThong/LoaiPhieuThuChi/LoaiPhieuThuChiApi";
import ReactDropdown from "react-dropdown";
import "react-dropdown/style.css";

export const ModalThemMoi = ({ show, onHide, item, onSaved }) => {
    const [isSubmit, setIsSubmit] = useState(false);
    const initData = {
        LoaiThuChiId: 0,
        Name: "",
        Type: 1,
    };
    const [dataLoaiPhieu, setDataLoaiPhieu] = useState(initData);
    const [errors, setErrors] = useState({ name: "" });

    useEffect(() => {
        if (show) {
            if (item && item.LoaiThuChiId > 0) {
                setDataLoaiPhieu({
                    LoaiThuChiId: item.LoaiThuChiId,
                    Name: item.Name || "",
                    Type: item.Type || 1,
                });
            } else {
                setDataLoaiPhieu(initData);
            }
            setErrors({ name: "" });
        }
    }, [show, item]);

    const typeOptions = [
        { value: 1, label: "Thu" },
        { value: 2, label: "Chi" }
    ];

    const updateTextValue = (field) => (e) => {
        const value = e.target.value;
        setDataLoaiPhieu(prev => ({ ...prev, [field]: value }));
        if (value.trim() === "") {
            setErrors({ ...errors, name: "Vui lòng nhập tên loại phiếu!" });
        } else {
            setErrors({ ...errors, name: "" });
        }
    };

    const handleTypeChange = (option) => {
        setDataLoaiPhieu(prev => ({ ...prev, Type: option.value }));
    };

    const validate = () => {
        let valid = true;
        let err = { name: "" };
        if (!dataLoaiPhieu.Name.trim()) {
            err.name = "Vui lòng nhập tên loại phiếu!";
            valid = false;
        }
        setErrors(err);
        return valid;
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        setIsSubmit(true);
        try {
            const res = await LoaiPhieuThuChiApi.addOrUpdate(dataLoaiPhieu);
            if (res.status === 200) {
                pushNotification("Thao tác thành công!", "success", "TOP_CENTER", 2000);
                if (onSaved) onSaved();
            } else {
                pushNotification("Thao tác thất bại!", "error", "TOP_CENTER", 2000);
            }
        } catch (error) {
            console.error("Lỗi khi lưu loại phiếu:", error);
            pushNotification("Có lỗi xảy ra, vui lòng thử lại!", "error", "TOP_CENTER", 2000);
        }
        setIsSubmit(false);
    };
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="modal-dialog modal-lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-new modal fade text-left"
        >
            <Modal.Header>
                <h4 className="modal-title color7-bold" id="myModalLabel16">
                    <span className="btn-icon-right">
                        <img
                            src={dataLoaiPhieu.LoaiThuChiId > 0 ? "/app-assets/images/icon-editphieuthuchi.png" : "/app-assets/images/icon-tao-moi-don-nhap-hang.png"}
                            alt="icon"
                        />
                    </span>
                    {dataLoaiPhieu.LoaiThuChiId > 0 ? "Sửa loại phiếu" : "Thêm mới loại phiếu"}
                </h4>
                <button
                    type="button"
                    className="close-popup-new"
                    onClick={onHide}
                >
                    <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                </button>
            </Modal.Header>
            <form onSubmit={handleFormSubmit}>
                <Modal.Body className="">
                    <div className="form form-horizontal">
                        <div className="form-body">
                            <div className="form-body">
                                <div className="form-group row">
                                    <label className="col-md-3 label-control color7-bold">
                                        Tên loại phiếu <span className="canh-bao-red">*</span>
                                    </label>
                                    <div className="col-md-9">
                                        <input
                                            type="text"
                                            className="form-control input-sm"
                                            value={dataLoaiPhieu.Name}
                                            onChange={updateTextValue("Name")}
                                            name="Name"
                                            placeholder="Nhập tên loại phiếu"
                                        />
                                        <span className="canh-bao-red">
                                            {errors.name}
                                        </span>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-3 label-control color7-bold">Loại</label>
                                    <div className="col-md-9">
                                        <ReactDropdown
                                            options={typeOptions}
                                            onChange={handleTypeChange}
                                            value={typeOptions.find(opt => opt.value === dataLoaiPhieu.Type)}
                                            controlClassName="form-control input-sm"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-new-main btn-closenew"
                        onClick={onHide}
                    >
                        <span>
                            <i className="mdi mdi-close"></i>
                        </span>
                        &nbsp; Đóng
                    </button>

                    <button type="submit" className="btn btn-new-main button-popup-submit" disabled={isSubmit}>
                        <span>
                            <img src="/app-assets/images/icon-send-v2.png" alt="save" />
                        </span>
                        &nbsp; {isSubmit ? "Đang lưu..." : (dataLoaiPhieu.LoaiThuChiId > 0 ? "Lưu thay đổi" : "Thêm mới")}
                    </button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};